import { render, staticRenderFns } from "./VhomeFoot.vue?vue&type=template&id=01918cbd&scoped=true&"
import script from "./VhomeFoot.vue?vue&type=script&lang=js&"
export * from "./VhomeFoot.vue?vue&type=script&lang=js&"
import style0 from "./VhomeFoot.vue?vue&type=style&index=0&id=01918cbd&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01918cbd",
  null
  
)

export default component.exports